export default __webpack_public_path__ + "static/media/product.f548dde1.webp";